<template>
  <div class="home">
    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card>
          <a-calendar mode="month">
            <ul slot="dateCellRender" slot-scope="value" class="events">
              <li v-for="item in getListData(value)" :key="item.content">
                <a-badge :status="item.type" :text="item.content"/>
              </li>
            </ul>
          </a-calendar>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// import httpClient from "../utils/httpClient";

export default {
  name: "Calendar",
  data() {
    return {
      data: [],
    };
  },
  components: {},
  mounted() {
    this.$emit("loadedView");
  },
  computed: {
    computedSession() {
      return this.$store.getters.getUserConnectionDetails;
    },
  },
  methods: {
    goTo(obj) {
      if (this.$route.name !== obj.name) {
        this.$router.push(obj);
      }
    },
    getListData(value) {
      let listData;
      switch (value.date()) {
        case 15:
          listData = [
            {type: 'success', content: 'D.S. Laura - aktualizacja'},
            {type: 'warning', content: 'D.S. Proton - brak sieci'},
          ];
          break;
        case 25:
          listData = [
            {type: 'processing', content: 'Aktualizacja'},
          ];
          break;
        default:
      }
      return listData || [];
    },
    getMonthData(value) {
      if (value.month() === 8) {
        return 1394;
      }
    },
  },
};
</script>

<style scoped>
.events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}
</style>